import { render, staticRenderFns } from "./TopicCategories.vue?vue&type=template&id=50afc07a&scoped=true"
import script from "./TopicCategories.vue?vue&type=script&lang=js"
export * from "./TopicCategories.vue?vue&type=script&lang=js"
import style0 from "./TopicCategories.vue?vue&type=style&index=0&id=50afc07a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50afc07a",
  null
  
)

export default component.exports